<template>
  <div class="mb-4 text-xl font-medium dark:text-white">
    {{ $t("Workspace Information") }}
  </div>
  <div class="flex mt-2 space-x-2">
    <label class="mt-2 mr-4 font-medium dark:text-white">{{ $t("Name") }}:</label>
    <div class="w-[350px]">
      <TextInput
        :no-border="false"
        name="name"
        :value="workspace_name"
        :is-box-background="false"
        :validate-on-input="false"
        type="text"
        :placeholder="$t('Name')"
        input-classes="border appearance-none block w-[200px] px-3 py-2 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light"
        @update:modelValue="
          ($event) => {
            workspace_name = $event
          }
        " />
    </div>
  </div>

  <div class="mt-12 mb-4 text-lg font-medium dark:text-white">
    {{ $t("Header Settings") }}
  </div>

  <div class="flex w-full mb-10 relative">
    <div class="w-1/3 cursor-pointer">
      <Image
        v-if="!logo"
        class="text-common-grey inline-block p-3 border rounded-md cursor-default dark:divide-dark-divider-border h-28 w-28" />
      <img v-else class="inline-block p-3 border rounded-md cursor-default dark:divide-dark-divider-border h-28" :src="logo" alt="">

      <!-- <img class="inline-block p-3 border rounded-md dark:divide-dark-divider-border h-28" src="https://www.freepnglogos.com/uploads/apple-logo-png/apple-logo-png-dallas-shootings-don-add-are-speech-zones-used-4.png" alt="" /> -->

      <button class="absolute ml-2 mt-10 pointer-events-none btn cancel-btn">
        <Image class="w-4 h-4 mr-2 text-common-grey" />{{ logo ? $t("Change header logo") : $t("Add header logo") }}
      </button>
      <input
        name="file-upload"
        accept="image/*"
        type="file"
        :placeholder="$t('here')"
        class="w-44 h-10 ml-2 mt-10 bg-red-500 border opacity-0 absolute cursor-pointer"
        @change="(e) => addFiles(e)">
    </div>

    <div class="flex justify-around w-2/3">
      <div v-click-outside="handleClickOutsideHeaderColor" class="text-center">
        <div>{{ $t("Selected Header Color") }}</div>
        <div>{{ selected_header_color }}</div>

        <div class="relative flex items-center w-full">
          <div :style="{ backgroundColor: selected_header_color }" class="w-8 h-8 mx-auto border rounded-md" />
        </div>
        <TextInput
          v-model="selected_header_color"
          class="relative opacity-0 cursor-pointer bottom-8"
          :value="selected_header_color"
          :validate-on-input="false"
          label=""
          classes="h-10 w-10 !p-0 flex items-center "
          input-classes="h-10 w-1 overflow-hidden appearance-none rounded-md !p-0 "
          name="color"
          type="color"
          :placeholder="$t('Tag Color')" />
      </div>
      <div v-click-outside="handleClickOutsideHeaderTextColor" class="text-center">
        <div>{{ $t("Selected Header Text Color") }}</div>
        <div>{{ selected_header_text_color }}</div>

        <div class="relative flex items-center w-full">
          <div :style="{ backgroundColor: selected_header_text_color }" class="w-8 h-8 mx-auto border rounded-md" />
        </div>
        <TextInput
          v-model="selected_header_text_color"
          :validate-on-input="false"
          class="relative opacity-0 cursor-pointer bottom-8"
          :value="selected_header_text_color"
          label=""
          classes="h-10 w-10 !p-0 flex items-center "
          input-classes="h-10 w-1 overflow-hidden appearance-none rounded-md !p-0 "
          name="color"
          type="color"
          placeholder="Tag Color" />
      </div>
    </div>
  </div>

  <div class="mt-12 mb-4 text-lg font-medium dark:text-white">
    {{ $t("Pages Settings") }}
  </div>
  <div class="relative mt-4 flex flex-col justify-center items-center text-center w-fit mb-10">
    <div>{{ $t("Background Color") }}:</div>
    <div>{{ $t(selected_background_page_color) }}</div>
    <ColorPickerList v-model:current-item="selected_background_page_color" class="relative flex justify-center items-center right-0.5" />
  </div>

  <div v-click-outside="handleClickOutsideDescription" class="relative flex mt-3 span-x-2">
    <label class="mt-3 font-medium dark:text-white whitespace-nowrap">{{ $t("Internal Description") }}:</label>
    <div class="w-full h-full mt-0 ml-4 border rounded-lg">
      <TextEditor
        :value="workspace_description"
        :show-label="false"
        :no-border="false"
        toolbar="essential"
        :placeholder="$t('Description')"
        name="internal_description"
        :label="$t('Description')"
        theme="bubble"
        input-classes="rounded-b-md"
        @changed="
          (e) => {
            workspace_description = e
          }
        " />
    </div>
  </div>

  <div class="flex items-center mt-4 space-x-6 span-x-2">
    <label class="font-medium">{{ $t("Selected Company") }}:</label>
    <div class="p-3 border rounded-md bg-gray-50">
      {{ workspace_record?.name }}
    </div>
    <!-- <TextInput v-if="workspace_record" :disabled="true" name="name" :value="workspace_record.name" :is-box-background="true" type="text" placeholder="Name" input-classes="border appearance-none block px-3 py-2 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light" /> -->

    <div v-if="workspace?.selected_template">
      <label class="font-medium">{{ $t("Selected Template") }}:</label>
      <TextInput
        :disabled="true"
        name="template"
        :value="$utils.capitalize(workspace?.selected_template?.replace('_', ' '))"
        :is-box-background="true"
        type="text"
        :placeholder="$t('Name')"
        input-classes="border appearance-none block w-full px-3 py-2 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light" />
    </div>
  </div>
</template>

<script>
import { Image } from "lucide-vue-next"
import TextInput from "@/components/shared/TextInput.vue"
import TextEditor from "@/components/shared/TextEditor.vue"
import ColorPickerList from "@/components/shared/ColorPickerList.vue"
const maxFileAllowedSizeMB = 20
const maxFileAllowedSize = maxFileAllowedSizeMB * 1024 * 1024
export default {
  components: { TextInput, TextEditor, Image, ColorPickerList },
  props: { workspace: null },
  emits: [],
  data() {
    return {
      workspace_name: "",
      logo: null,
      workspace_description: "",
      selected_header_text_color: "",
      selected_header_color: "",

      dont_trigger: false,
      workspace_record: null,
      header_color_changed: false,
      header_text_color_changed: false,
      description_changed: false,
      selected_background_page_color: "transparent"
    }
  },

  watch: {
    workspace() {
      if (this.workspace) {
        if (this.$store.state.data.records_fetched[this.workspace?.record]) {
          this.workspace_record = this.$store.state.data.records_fetched[this.workspace?.record]
        } else {
          this.$store.dispatch("data/getRecord", this.workspace?.record).then((res) => {
            this.workspace_record = res.data
          })
        }

        this.dont_trigger = true
        setTimeout(() => {
          this.dont_trigger = false
        }, 100)

        this.initWorkspace()
      }
    },
    workspace_name() {
      if (!this.dont_trigger) {
        if (this.workspace_name) {
          this.$store.dispatch("data/updateWorkspace", {
            short_id: this.workspace?.short_id,
            name: this.workspace_name
          })
        }
      }
    },
    workspace_description() {
      if (!this.dont_trigger) {
        this.description_changed = true
      }
    },

    selected_header_text_color() {
      if (!this.dont_trigger) {
        this.updateWorkspace()
      }
    },
    selected_header_color() {
      if (!this.dont_trigger) {
        this.updateWorkspace()
      }
    },

    selected_background_page_color() {
      if (!this.dont_trigger) {
        this.updateWorkspace()
      }
    }
  },

  created() {
    if (this.workspace) {
      if (this.$store.state.data.records_fetched[this.workspace?.record]) {
        this.workspace_record = this.$store.state.data.records_fetched[this.workspace?.record]
      } else {
        this.$store.dispatch("data/getRecord", this.workspace?.record).then((res) => {
          this.workspace_record = res.data
        })
      }
    }

    this.dont_trigger = true
    setTimeout(() => {
      this.dont_trigger = false
    }, 100)

    this.initWorkspace()
  },

  methods: {
    handleClickOutsideHeaderColor() {
      if (this.header_color_changed) {
        this.updateWorkspace()
        this.header_color_changed = false
      }
    },
    handleClickOutsideHeaderTextColor() {
      if (this.header_text_color_changed) {
        this.updateWorkspace()
        this.header_text_color_changed = false
      }
    },

    handleClickOutsideDescription() {
      if (this.description_changed) {
        this.updateWorkspace()
        this.description_changed = false
      }
    },
    initWorkspace() {
      this.workspace_name = this.workspace?.name
      this.workspace_description = this.workspace?.description
      this.selected_header_text_color = this.workspace?.header_text_color
      this.selected_header_color = this.workspace?.header_color
      this.selected_background_page_color = this.workspace?.page_background_color
      this.logo = this.$utils.extractUrl(this.workspace?.logo)
    },

    updateWorkspace() {
      if (!this.dont_trigger) {
        this.$store.dispatch("data/updateWorkspace", {
          short_id: this.workspace?.short_id,
          page_background_color: this.selected_background_page_color,
          header_text_color: this.selected_header_text_color,
          header_color: this.selected_header_color,
          description: this.workspace_description
        })
      }
    },
    addFiles(event) {
      Array.from(event.target.files).map((file) => {
        if (file.size < maxFileAllowedSize) {
          this.$store
            .dispatch("data/updateWorkspace", {
              short_id: this.workspace?.short_id,
              logo: file
            })
            .then((res) => {
              this.logo = this.$utils.extractUrl(res.data.logo)
            })
        }
      })
    }
  }
}
</script>
